import styled from "styled-components";

export const Container = styled.div`
  max-width: 80%;
  overflow: hidden;
  .check-icon {
    margin-left: 0.5rem;
  }
`;
